import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    //clientId: "79b30a01-7f90-4b08-9d5c-250e42fc408d",
    clientId:"5589420b-667d-45e6-9ad5-6aecde388265", //prod
    authority:
      "https://login.microsoftonline.com/8dfe34a9-11b2-4413-b17d-64d0c107ed14",
    //redirectUri: "https://devweboralexamineras01.azurewebsites.net",
    redirectUri: "https://weboralexamineras01.azurewebsites.net", //prod
    postLogoutRedirectUri: "/",
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft-ppe.com/v1.0/me",
};
